import React, { useState, useEffect } from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled from 'styled-components';
import { _ as _taggedTemplateLiteral, c as _slicedToArray } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_arrayReduce-35053fa6.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './reduce-359d9da9.js';
import './_isIterateeCall-c4941c92.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import { _ as _map } from './map-651e82c0.js';
import './join-15b17329.js';
import { _ as _noop } from './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import './Typographies.js';
import './index-f96168ba.js';
import './isNull-db706d68.js';
import './chain-d06384bf.js';
import Button from './Button.js';
import { c as createCompounder, u as upperFirst, g as getSpacesAsCss } from './getSpacesAsCSS-2c03c4c1.js';
import './_hasUnicode-6e5e26e7.js';
import { _ as _range } from './range-409eafd0.js';
import { format, getMonth, getYear, isDate, addMonths, setMonth, setYear } from 'date-fns';
import { c as chainedRender } from './chainedRender-bf38fc02.js';
import './isString-30e5fe84.js';
import Select from './Select.js';

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */


var startCase = createCompounder(function (result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});
var startCase_1 = startCase;

var getMonthNames = function getMonthNames() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var monthNames = [];

  for (var i = 0; i < 12; i++) {
    monthNames.push({
      id: i,
      name: startCase_1(format(new Date(2019, i, 1), 'MMMM', {
        locale: locale
      }))
    });
  }

  return monthNames;
}; // Memoize result, avoid recreating a new array each time, avoid causing useless react rerender,

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  padding: ", ";\n\n  ", ":last-child {\n    flex-shrink: 2;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledMonthContainer = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return getSpacesAsCss(theme.components.inputTime, 'padding');
}, Select);

var renderContainer = function renderContainer(className, children) {
  return React.createElement(StyledMonthContainer, {
    className: className
  }, children);
};

var renderCurrentMonth = function renderCurrentMonth(currentDate, monthNames, _onChange) {
  return React.createElement(Select, {
    id: "currentMonthSelector",
    options: monthNames,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    value: getMonth(currentDate)
  });
};

var renderCurrentYear = function renderCurrentYear(currentDate, yearRange, _onChange) {
  return React.createElement(Select, {
    id: "currentYearSelector",
    options: _map(_range(yearRange[1], yearRange[0]), function (val) {
      return {
        id: val,
        name: val
      };
    }),
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    value: getYear(currentDate)
  });
};

var renderControlButton = function renderControlButton(currentDate, side, onChange) {
  return React.createElement(Button, {
    onClick: onChange,
    variant: "neutral"
  }, side === 'next' ? '>' : side === 'prev' ? '<' : '*');
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var InputMonth = function InputMonth(_ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      onChange = _ref.onChange,
      yearRange = _ref.yearRange,
      _ref$withNextPrevButt = _ref.withNextPrevButtons,
      withNextPrevButtons = _ref$withNextPrevButt === void 0 ? false : _ref$withNextPrevButt,
      locale = _ref.locale,
      containerRender = _ref.containerRender,
      controlButtonRender = _ref.controlButtonRender,
      monthRender = _ref.monthRender,
      yearRender = _ref.yearRender;

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1]; // Sync with value if in controlled state


  useEffect(function () {
    if (isDate(value)) {
      setStateValue(value);
    }
  }, [value]);

  var handleMutatorOnChange = function handleMutatorOnChange(value, mutator) {
    var newDate = mutator(stateValue, value);
    setStateValue(newDate);
    onChange(newDate);
  };

  var handleOnChange = function handleOnChange(value) {
    setStateValue(value);
    onChange(value);
  };

  return chainedRender(renderContainer, containerRender, className, React.createElement(React.Fragment, null, withNextPrevButtons && chainedRender(renderControlButton, controlButtonRender, stateValue, 'prev', function () {
    return handleOnChange(addMonths(stateValue, -1));
  }), chainedRender(renderCurrentMonth, monthRender, stateValue, getMonthNames(locale), function (val) {
    return handleMutatorOnChange(val, setMonth);
  }), chainedRender(renderCurrentYear, yearRender, stateValue, yearRange, function (val) {
    return handleMutatorOnChange(val, setYear);
  }), withNextPrevButtons && chainedRender(renderControlButton, controlButtonRender, stateValue, 'next', function () {
    return handleOnChange(addMonths(stateValue, 1));
  })));
};

InputMonth.defaultProps = {
  className: '',
  defaultValue: new Date(),
  value: null,
  onChange: _noop,
  yearRange: [2000, 2040],
  containerRender: null,
  monthRender: null,
  yearRender: null,
  locale: null
};
InputMonth.propTypes = {
  /**
   * The classes of the select.
   */
  className: PropTypes.string,
  defaultValue: PropTypes.instanceOf(Date),
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  yearRange: PropTypes.arrayOf(PropTypes.number),
  containerRender: PropTypes.func,
  monthRender: PropTypes.func,
  yearRender: PropTypes.func,
  locale: PropTypes.any
};
/** @component */

var InputMonth$1 = styled(React.memo(InputMonth))(_templateObject$1());

export default InputMonth$1;
